import {useMemo} from 'react';
import {useBenefactorPointsAssignment} from '../../hooks';
import {BenefactorPointsAssignmentTable} from '../BenefactorPointsAssignmentTable';
import {PointsAssignmentModel} from '../../model';

interface BenefactorPointsAssignmentHistoryProps {
  benefactorId: string | undefined;
}

export const BenefactorPointsAssignmentHistory = ({benefactorId}: BenefactorPointsAssignmentHistoryProps) => {
  const {getInfinitePointsAssignment} = useBenefactorPointsAssignment(benefactorId || '');

  const {data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage} = getInfinitePointsAssignment;

  const assignments: PointsAssignmentModel[] = useMemo(() => {
    return data?.pages.flatMap((page) => page.items) || [];
  }, [data]);

  return (
    <BenefactorPointsAssignmentTable
      assignments={assignments}
      isLoading={isLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      benefactorId={benefactorId || ''}
    />
  );
};
